<template>
  <div v-if="calculation && elements_length != 0" style="white-space: nowrap; display: flex; flex-direction: row; text-align: center; width: 260px; justify-content: space-between">
      <div v-if="!show_step " style="overflow: hidden;padding-left: 3px; width: 80px; padding-right: 3px; border: solid 1.5px; border-radius: 3px"> {{Math.round(value_one * 100) / 100}} {{unit_one}} </div>
      <div v-if="!show_step"> * {{factor}} {{result_unit}} / {{unit_one}} = </div>
      <div v-if="show_step" > {{factor}} {{result_unit}} / {{unit_one}} {{mass_relation}} </div>
      <div class="" style="overflow: hidden;overflow: hidden; max-width: 70px; min-width: 70px; padding-left: 3px; padding-right: 3px; border: solid 1.5px; border-radius: 3px; text-align: right"> {{Math.round(value_one * factor * 100) / 100}} {{result_unit}} </div>
  </div>
  <div v-else-if="mass_relation === 'absolute'" style="overflow: hidden; max-width: 70px; min-width: 70px; padding-left: 3px; padding-right: 3px; border: solid 1.5px; border-radius: 3px; text-align: right"> {{factor}} {{result_unit}} </div>
  <div v-else-if="show_step" style="white-space: nowrap;"> {{factor}} {{result_unit}} / {{unit_one}} {{mass_relation}} </div>
  <div v-else style="white-space: nowrap;"> {{factor}} {{result_unit}} / {{unit_one}} </div>
</template>

<script>
export default {

  props: [
    'value_one',
    'unit_one',
    'factor',
    'result_unit',
    'mass_relation',
    'calculation',
    'show_step',
    'elements_length'
  ]
}
</script>
